import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";

export default class APIOrderId extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postReserve = async (orderId: UUID): Promise<any> => {
    let res = await this._fetch({
      url: `/orders/${orderId}/reserve`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postSend = async (
    orderId: UUID,
    { paymentDueDate }: { paymentDueDate?: string | null } = {},
  ): Promise<any> => {
    let res = await this._fetch({
      url: `/orders/${orderId}/send`,
      method: "POST",
      params: { payment_due_date: paymentDueDate },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postPaidoff = async (orderId: UUID): Promise<any> => {
    let res = await this._fetch({
      url: `/orders/${orderId}/paidoff`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postCancel = async (orderId: UUID): Promise<any> => {
    let res = await this._fetch({
      url: `/orders/${orderId}/cancel`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
